import React from "react";
import withWidth, { isWidthUp } from '@material-ui/core/withWidth';
import { useParams } from "react-router-dom";

import Tickets from "../TicketsCustom"
import TicketAdvanced from "../TicketsAdvanced";

function TicketResponsiveContainer (props) {
     const { ticketId } = useParams();
     
     if (isWidthUp('md', props.width)) {
        return <Tickets />;    
     }
     
     // No mobile, se há um ticketId na URL, renderizar o TicketAdvanced
     // que irá mostrar a conversa específica do ticket
     if (ticketId && ticketId !== "undefined") {
        return <TicketAdvanced />;
     }
     
     // No mobile, sem ticketId, renderizar o Tickets (lista de tickets)
     return <Tickets />;
}

export default withWidth()(TicketResponsiveContainer);